export class MetricValueUpdate {
  public metricId!: number;
  public value!: number | boolean | string;
  public timestamp!: number;

  constructor(metricId?: number, timestamp?: number, value?: number | boolean | string) {

    if (!!metricId) {
      this.metricId = metricId;
    }

    if (!!timestamp) {
      this.timestamp = timestamp;
    }

    if (value !== undefined && value !== null) {
      this.value = value;
    }

  }
}
